export default __webpack_public_path__ + "static/startup-girl-aa7dc937a7234d4a1528b01b009178c3.png";